export const Modal = {
  content: '',
  active: false,
  open(content) {
    this.content = content;
    this.active = true;
    document.querySelector('#modal a').focus();
  },
  close() {
    this.active = false;
    // Kill modal contents after fade out
    setTimeout(() => {
      this.content = '';
    }, 300);
  }
};
